import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PipelineLicenseStakeholderDto, StakeholderRepDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-stakeholderrep',
  templateUrl: './stakeholderrep.component.html',
  styleUrls: ['./stakeholderrep.component.scss']
})
export class StakeholderrepComponent implements OnInit {

  @Input() stakeholderreps: StakeholderRepDto[];
  @Input() stakeholders: PipelineLicenseStakeholderDto[];
  stakeholderRepForm: FormGroup;
  stakeholderRepFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<StakeholderRepDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredStakeholderRep: Array<any> = [];
  status: boolean;
  selectedStakeholderId: any;
  selectedIndex = null;

  selectedStakeholder = false;
  selectedStakeholderName = '';

  constructor(private fb: FormBuilder) {}

  ngOnInit() {   
    this.createStakeholderRepForm();
  }

  createStakeholderRepForm() {
    this.stakeholderRepFormArray = this.fb.group({ StakeholderReps: this.fb.array([]) });
    this.stakeholderRepForm = this.fb.group({
      StakeholderRepName: ['', Validators.required],
      StakeholderRepPhone: [''],
      StakeholderRepEmail: ['', Validators.required],
      StakeholderRepDesignation: [''],
      StakeholderRepStatus: [''],
      PipelineLicenseStakeholderId: this.selectedStakeholderId,
        id: null
    });
  }


  // method to display StakeholderRep
  setStakeholderRep() {
    const control = this.stakeholderRepFormArray.controls.StakeholderReps as FormArray;
    this.filteredStakeholderRep.forEach((e) => {
      control.push(
        this.fb.group({
      StakeholderRepName: e.StakeholderRepName,
      StakeholderRepPhone: e.StakeholderRepPhone,
      StakeholderRepEmail: e.StakeholderRepEmail,
      StakeholderRepDesignation: e.StakeholderRepDesignation,
      PipelineLicenseStakeholderId: e.PipelineLicenseStakeholderId,  
      StakeholderRepStatus: e.StakeholderRepStatus,        
          id: e.id,
        })
      );
    });
  }

   // method to add StakeholderRep
   addStakeholder(stakeholder: StakeholderRepDto) {
    const control = this.stakeholderRepFormArray.controls.StakeholderReps as FormArray;
    control.insert(
      0,
      this.fb.group({
        StakeholderRepName: stakeholder.StakeholderRepName,
        StakeholderRepPhone: stakeholder.StakeholderRepPhone,
        StakeholderRepEmail: stakeholder.StakeholderRepEmail,
        StakeholderRepDesignation: stakeholder.StakeholderRepDesignation,
        PipelineLicenseStakeholderId: this.selectedStakeholderId,
        StakeholderRepStatus: stakeholder.StakeholderRepStatus,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.stakeholderRepFormArray.controls.StakeholderReps as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter stakeholderreps
  selectStakeholder(event: string) {
    this.filteredStakeholderRep = this.stakeholderreps.filter((s) => s.PipelineLicenseStakeholderId === event);
    this.selectedStakeholderId = event;

    
    const control = this.stakeholderRepFormArray.controls.StakeholderReps as FormArray;

    if (this.filteredStakeholderRep.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setStakeholderRep();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }


    let getSingleStakeholder = this.stakeholders.find((s) => s.id === event);

     console.log("Single Stakeholder ", this.stakeholders,event);
    if(getSingleStakeholder)
    {
      this.selectedStakeholder = true;
      this.selectedStakeholderName = getSingleStakeholder.PipelineLicenseStakeholderName;
    }else{
      this.selectedStakeholder = false;
      this.selectedStakeholderName = '';
    }
  }

  print(event: any) {
    window.print();
  }

 
  // method to delete company from arrary list
  deleteStakeholderRep(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stakeholderRepFormArray.controls.StakeholderReps as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.stakeholderreps.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.stakeholderreps[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: StakeholderRepDto) {
    if(this.stakeholderRepForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.stakeholderRepFormArray.get('StakeholderReps')['controls'][this.selectedIndex].
      patchValue({StakeholderRepName: formValue.StakeholderRepName, 
        StakeholderRepPhone: formValue.StakeholderRepPhone,
        StakeholderRepEmail: formValue.StakeholderRepEmail,
        StakeholderRepDesignation: formValue.StakeholderRepDesignation, 
        StakeholderRepStatus: formValue.StakeholderRepStatus,
        PipelineLicenseStakeholderId: formValue.PipelineLicenseStakeholderId
      });
    } else {
      this.addStakeholder(formValue);
      const stakeHolderRepsControl =  (this.stakeholderRepFormArray.get('StakeholderReps') as FormArray);
      const lastValue = stakeHolderRepsControl.at(0).value;
      
      console.log("Last Value: ", lastValue);
      stakeHolderRepsControl.value.forEach((element, index, a) => {
        console.log("Value: ", element, " index: ", index, lastValue.StakeholderRepStatus);
        if(lastValue.StakeholderRepStatus == "Active" && element != lastValue){
          // make the current element inactive 
          // console.log("Value @ ", index, ' ', element);
          stakeHolderRepsControl.at(index).patchValue({StakeholderRepStatus: 'InActive'});
        }
        //  if(lastValue.StakeholderRepStatus == "InActive" && element != lastValue){
        //    stakeHolderRepsControl.at(index).patchValue({StakeholderRepStatus: 'Active'})
        // }
      });
    }
    this.selectedIndex = null;
    this.stakeholderRepForm.reset()
  }

  onEdit(index, value: StakeholderRepDto) {
    this.selectedIndex = index;
    this.stakeholderRepForm.patchValue({StakeholderRepName: value.StakeholderRepName,StakeholderRepPhone: value.StakeholderRepPhone,StakeholderRepEmail: value.StakeholderRepEmail,StakeholderRepDesignation: value.StakeholderRepDesignation,StakeholderRepStatus: value.StakeholderRepStatus, PipelineLicenseStakeholderId: value.PipelineLicenseStakeholderId});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.stakeholderRepForm.reset();
  }


  onSubmit(formValue: any) {
    console.log('stale ', formValue)
        
    formValue.type = 'stakeholder';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
     
      this.filteredDelete.unshift('stakeholder');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
